// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ed431080","667":"dfb565ab"}[chunkId] + ".chunk.js";
};